import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import VariationOrderList from './List';
import VariationOrderCreate from './Create';
import VariationOrderDetail from './Detail';

const defaultFields = {
    ProposedVariation: { visible: false, label: '', required: false },
    Subject: { visible: false, label: '', required: false },
    PriceEffect: { visible: false, label: '', required: false },
    TimeEffect: { visible: false, label: '', required: false },
    Details: { visible: false, label: '', required: false },
    CompensationType: { visible: false, label: '', required: false }
}


///ALL FIELDS ARE DECIDED WITHIN THE getFields FUNCTION
///THE getFields FUNCTION IS CALLED WITHIN THE adjustContractTemplate and assign fields to workflowItem
export const getFields = (resources, placeholdersQA, workflowsQA, languageFile, wfid, globalResources, contract) => {
    const fields = JSON.parse(JSON.stringify(defaultFields));
    const workflowItem = workflowsQA[wfid];

    fields.ProposedVariation = { visible: true, label: "Proposed Variation", required: true };
    fields.Subject = { visible: true, label: "Subject", required: true };
    fields.PriceEffect = { visible: true, label: "Price Effect", required: true };
    fields.TimeEffect = { visible: true, label: "Time Effect", required: true };
    fields.Details = { visible: true, label: "Details", required: true };
    fields.CompensationType = { visible: true, label: "Type", required: true };

    let clauses = workflowItem.clauses;

    fields.CompensationType.clauses = clauses;

    placeholdersQA.FieldsVariationOrder?.values?.forEach(fieldItem => {
        if (fields[fieldItem.field]) {
            fields[fieldItem.field].visible = fieldItem.isActive;
            fields[fieldItem.field].label = fieldItem.display;
        }
    });
    if (contract?.ispackaged === true) {
        fields.PriceEffect.visible = false;
    }
    
    return fields;
}



class VariationOrderRouter extends React.Component {
    constructor(props) {
        super(props);

        this.notifyingParty = props.workflowItem.notifyingParty;
        this.replyingParty = props.workflowItem.replyingParty;

        this.notificationName = props.workflowItem.notificationName;
        this.abbreviation = props.workflowItem.abbreviation;

    }

    shouldComponentUpdate() {
        return false;
    }
    render() {
        const { workflowItem } = this.props;
        return (
            <Routes caseSensitive>
                <Route path={workflowItem.paths.basePath} exact element={<Navigate replace to={workflowItem.paths.defaultPath} />} />
                <Route
                    path={workflowItem.config.paths.list}
                    exact
                    element={<VariationOrderList
                        {...this.props}
                        title={this.notificationName}
                        abbreviation={this.abbreviation}
                    />}

                />
                <Route
                    path={workflowItem.config.paths.create}
                    exact
                    element={
                        workflowItem.userFilters.mainNotice.createAllowed ? (
                            <VariationOrderCreate
                                {...this.props}
                                mode={this.props.mode}
                                title={this.notificationName}
                            />) : (
                            <Navigate replace to={workflowItem.paths.defaultPath} />
                        )
                    }
                />
                <Route
                    path={'/:notificationid/*'}
                    element={<VariationOrderDetail
                        {...this.props}
                        mode={this.props.mode}
                        title={this.notificationName}
                        abbreviation={this.abbreviation}
                        notifyUserFilter={workflowItem.notifyUserFilter}
                    />}
                />
            </Routes>
        );
    }
};




export default (VariationOrderRouter);